<template>
  <div class="switcher-container">
    <div class="toggle-switch">
      <input
        type="checkbox"
        :id="id"
        :name="name"
        :checked="value"
        :disabled="disabled"
        class="toggle-switch__input"
        @change="handleChange"
      />
      <span
        class="toggle-switch__track"
        :class="{ 'is-disabled': disabled }"
        @click="handleTrackClick"
      >
        <span class="toggle-switch__thumb"></span>
        <span class="visually-hidden">{{ label }}</span>
      </span>
    </div>
    <label :class="{ 'is-disabled': disabled }" :for="id" class="toggle-switch__label">{{
      label
    }}</label>
  </div>
</template>

<script>
export default {
  name: 'BaseSwitcher',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleChange(event) {
      this.$emit('change', event.target.checked, this.name)
    },
    handleTrackClick() {
      if (!this.disabled) {
        this.$emit('change', !this.value, this.name)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.switcher-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.toggle-switch {
  position: relative;
  display: inline-block;

  &__input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  &__track {
    display: block;
    width: 42px;
    height: 22px;
    background-color: var(--color-133);
    border-radius: 22px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    position: relative;
  }

  &__thumb {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 18px;
    height: 18px;
    background-color: var(--color-01);
    border-radius: 50%;
    transition: transform 0.2s ease;
  }

  &__input:checked + &__track {
    background-color: var(--color-23);

    .toggle-switch__thumb {
      transform: translateX(20px);
    }
  }

  &__label {
    cursor: pointer;
    user-select: none;
    margin-top: -3px;
  }
}

.is-disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
